import React from "react";
import { MuellerThemeContext, MuellerThemeProviderValue } from "components/Shared/MuellerThemeProvider";
import { useContext } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const ThemeSelection = () => {
  const themeContext = useContext<MuellerThemeProviderValue>(MuellerThemeContext);

  return (
    <div className="user-preference-selection-control">
      <RadioGroup
        name="theme"
        value={themeContext.currentTheme.code}
        onChange={e => themeContext.changeTheme(e.target.value)}>
          {themeContext.themeOptions.map(t => (
            <FormControlLabel className="theme-choice" value={t.code} control={<Radio />} label={<><i className="material-icons">{t.iconName}</i><span className="theme-name">{t.displayName}</span></>} />
          ))}
      </RadioGroup>
    </div>
  );
};

export default ThemeSelection;
